import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import EditButton from "../provider-management/components/buttons/EditButton";

import useProviderDetailPrimarySection from "./hooks/useProviderDetailPrimarySection";
import PrimarySectionActions from "./sections/primary/PrimarySectionActions";
import PrimaryTextFields from "./sections/primary/PrimaryTextFields";
import ProviderTypesField from "./sections/primary/ProviderTypesField";
import ProviderDetailSectionCard from "./sections/shared/ProviderDetailSectionCard";
import ProviderDetailSectionTitle from "./sections/shared/ProviderDetailSectionTitle";

export default function ProviderDetailPrimarySection({
  permissionState,
  providerInformation,
  setProviderInformation,
}) {
  const section = useProviderDetailPrimarySection({
    canViewProviderTypes: permissionState?.canViewProvider,
    providerInformation,
    setProviderInformation,
  });

  return (
    <ProviderDetailSectionCard>
      <div className="grid gap-4">
        <div className="flex items-center justify-between gap-3">
          <ProviderDetailSectionTitle>General Information</ProviderDetailSectionTitle>
          <Tooltip title="Edit">
            <span>
              <EditButton
                disabled={section.isEditing || !permissionState?.canEditProvider}
                handleOnClick={
                  !section.isEditing && permissionState?.canEditProvider
                    ? () => section.setIsEditing(true)
                    : undefined
                }
              />
            </span>
          </Tooltip>
        </div>

        {permissionState?.canViewProvider ? (
          <ProviderTypesField
            helperText={section.providerTypeHelperText}
            isEditing={section.isEditing}
            loading={section.providerTypeState.loading}
            onChange={(_, value) => section.updateField("providerTypes", value)}
            onLoadMore={section.loadMoreProviderTypes}
            onSearchChange={section.setSearch}
            options={section.providerTypeState.options}
            selectedOptions={section.formState.providerTypes}
            showMore={section.providerTypeState.showMore}
          />
        ) : null}

        <PrimaryTextFields
          formState={section.formState}
          isEditing={section.isEditing}
          onChange={section.updateField}
        />

        {section.isEditing ? (
          <PrimarySectionActions
            disabled={section.saveDisabled}
            isSaving={section.isSaving}
            onCancel={section.cancelEditing}
            onSave={section.saveChanges}
          />
        ) : null}
      </div>
    </ProviderDetailSectionCard>
  );
}

ProviderDetailPrimarySection.propTypes = {
  permissionState: PropTypes.object.isRequired,
  providerInformation: PropTypes.object.isRequired,
  setProviderInformation: PropTypes.func.isRequired,
};
